import "./styles.css";

import logoImage from "../../assets/logo.png";
import icons from "../../constants/icons";

const Logo = (props) => {
  return (
    <div className={`logo-container ${props.className}`}>
      <div
        className={`mobile-container ${
          props.type === "dashboard" ? "show" : ""
        }`}
        onClick={props.handleMenuIconClicked}
      >
        <div className="icon-container no-hover-bg">
          <span className={process.env.REACT_APP_ICONS_TYPE}>{icons.menu}</span>
        </div>
      </div>

      <div
        className="logo-brand"
        onClick={() => (window.location.href = "/landing")}
      >
        <div className="logo-left">
          <div className="image-container">
            <img src={logoImage} alt="Rwanda Coat of Arms" />
          </div>
          <div className="org-text">
            <span className="org-country">Republic of Rwanda</span>
            <div className="org-line" />
            <span className="org-ministry">Ministry of Health</span>
          </div>
        </div>

        <div className="logo-right">
          <span className="logo-rbc">
            <span className="rbc-r">R</span>
            <span className="rbc-b">B</span>
            <span className="rbc-c">C</span>
          </span>
          <span className="logo-bbms">BBMS</span>
        </div>
      </div>
    </div>
  );
};

export default Logo;
